"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ErrorWithSupportLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactUse = require("react-use");
var _reactUi = require("@100mslive/react-ui");
var _Header = require("./Header");
var _DialogContent = require("../primitives/DialogContent");
var _useUISettings = require("./AppData/useUISettings");
var _PreviewContainer = _interopRequireDefault(require("./Preview/PreviewContainer"));
var _SidePane = _interopRequireDefault(require("../layouts/SidePane"));
var _useNavigation = require("./hooks/useNavigation");
var _constants = require("../common/constants");
var _utils = require("../common/utils");
var _reactSdk = require("@100mslive/react-sdk");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
/**
 * query params exposed -
 * skip_preview=true => used by recording and streaming service, skips preview and directly joins
 *                      header and footer don't show up in this case
 * skip_preview_headful=true => used by automation testing to skip preview without impacting the UI
 * name=abc => gives the initial name for the peer joining
 * auth_token=123 => uses the passed in token to join instead of fetching from token endpoint
 * ui_mode=activespeaker => lands in active speaker mode after joining the room
 */

var env = "prod";
var PreviewScreen = /*#__PURE__*/_react["default"].memo(function (_ref) {
  _objectDestructuringEmpty(_ref);
  var navigate = (0, _useNavigation.useNavigation)();
  var _useSetUiSettings = (0, _useUISettings.useSetUiSettings)(_constants.UI_SETTINGS.isHeadless),
    _useSetUiSettings2 = _slicedToArray(_useSetUiSettings, 2),
    setIsHeadless = _useSetUiSettings2[1];
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId,
    token = _useParams.token; // from the url
  var _useState = (0, _react.useState)({
      title: "",
      body: ""
    }),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];

  // way to skip preview for automated tests, beam recording and streaming
  var beamInToken = (0, _reactUse.useSearchParam)("token") === "beam_recording"; // old format to remove
  var skipPreview = (0, _reactUse.useSearchParam)(_constants.QUERY_PARAM_SKIP_PREVIEW) === "true";

  // use this field to join directly for quick testing while in local
  var directJoinHeadfulFromEnv = process.env.REACT_APP_HEADLESS_JOIN === "true";
  var directJoinHeadful = (0, _reactUse.useSearchParam)(_constants.QUERY_PARAM_SKIP_PREVIEW_HEADFUL) === "true" || directJoinHeadfulFromEnv;
  skipPreview = skipPreview || beamInToken || directJoinHeadful;
  var participantName = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.participantName));
  var onJoin = function onJoin() {
    !directJoinHeadful && setIsHeadless(skipPreview);
    var meetingURL = "".concat((0, _utils.getRoutePrefix)(), "/").concat(sessionId, "/meeting/").concat(token);
    navigate(meetingURL);
  };
  if (error.title) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.ErrorDialog, {
      title: error.title,
      children: error.body
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    direction: "column",
    css: {
      size: "100%"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        h: "$18",
        "@md": {
          h: "$17",
          flexShrink: 0
        }
      },
      "data-testid": "header",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
        isPreview: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        flex: "1 1 0",
        position: "relative",
        overflowY: "auto"
      },
      justify: "center",
      align: "center",
      children: [token ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreviewContainer["default"], {
          initialName: participantName,
          skipPreview: skipPreview,
          env: env,
          onJoin: onJoin,
          token: token
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Loading, {
        size: 100
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePane["default"], {
        css: {
          position: "unset",
          mr: "$10",
          "@lg": {
            position: "fixed",
            mr: "$0"
          }
        }
      })]
    })]
  });
});
var convertPreviewError = function convertPreviewError(error) {
  console.error("[error]", {
    error: error
  });
  if (error.response && error.response.status === 404) {
    return {
      title: "Room does not exist",
      body: ErrorWithSupportLink("We could not find a room corresponding to this link.")
    };
  } else if (error.response && error.response.status === 403) {
    return {
      title: "Accessing room using this link format is disabled",
      body: ErrorWithSupportLink("You can re-enable this from the developer section in Dashboard.")
    };
  } else {
    console.error("Token API Error", error);
    return {
      title: "Error fetching token",
      body: ErrorWithSupportLink("An error occurred while fetching the app token. Please look into logs for more details.")
    };
  }
};
var Link = (0, _reactUi.styled)("a", {
  color: "#2f80e1"
});
var ErrorWithSupportLink = function ErrorWithSupportLink(errorMessage) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [errorMessage, " If you think this is a mistake on our side, please create", " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
      target: "_blank",
      href: "https://github.com/100mslive/100ms-web/issues",
      rel: "noreferrer",
      children: "an issue"
    }), " ", "or reach out over", " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
      target: "_blank",
      href: "https://discord.com/invite/kGdmszyzq2",
      rel: "noreferrer",
      children: "Discord"
    }), "."]
  });
};
exports.ErrorWithSupportLink = ErrorWithSupportLink;
var _default = PreviewScreen;
exports["default"] = _default;